import { c as _c } from "react/compiler-runtime";
import { css } from '@repo/pandacss/css';
import { Typography } from '@repo/ui/Typography';
import { CreditCardIconFilled } from '../../Icons';
import type { CommonProductCard, CtaAnalyticsProps, SegmentActionNamePrefixType } from '../../types';
import { Accordion } from '../Accordion';
import { RatesAndFeesAnalyticsLink } from './RatesAndFeesAnalyticsLink';
const cardDetailsListItem = css({
  display: 'list-item',
  p: '0',
  '&:not(:last-of-type)': {
    pb: '2'
  }
});
export const CardDetails = t0 => {
  const $ = _c(19);
  const {
    actionSection,
    analytics,
    creditCardOffer,
    segmentActionNamePrefix,
    expandedByDefault
  } = t0;
  const {
    details: t1,
    name
  } = creditCardOffer;
  const {
    applyLink,
    isActive,
    isMonetizing,
    termsFeesLink,
    marketingBullets,
    versionId
  } = t1;
  const isReview = !isActive || !isMonetizing || !applyLink;
  const t2 = `${segmentActionNamePrefix}_card_details`;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <CreditCardIconFilled />;
    $[0] = t3;
  } else {
    t3 = $[0];
  }
  let t4;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = css({
      listStyleType: "disc",
      paddingInlineStart: "3",
      px: {
        base: "3",
        _pcMd: "3.5"
      },
      py: "0",
      my: "0"
    });
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  let t5;
  if ($[2] !== marketingBullets) {
    t5 = marketingBullets?.map(_temp);
    $[2] = marketingBullets;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  let t6;
  if ($[4] !== actionSection || $[5] !== analytics || $[6] !== isReview || $[7] !== name || $[8] !== termsFeesLink || $[9] !== versionId) {
    t6 = !isReview && termsFeesLink && <li className={cardDetailsListItem}><RatesAndFeesAnalyticsLink analytics={analytics} href={termsFeesLink} versionId={versionId} actionSection={actionSection} name={name} /></li>;
    $[4] = actionSection;
    $[5] = analytics;
    $[6] = isReview;
    $[7] = name;
    $[8] = termsFeesLink;
    $[9] = versionId;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t5 || $[12] !== t6) {
    t7 = <ul className={t4} data-testid="cardDetailsInnerContent">{t5}{t6}</ul>;
    $[11] = t5;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== actionSection || $[15] !== expandedByDefault || $[16] !== t2 || $[17] !== t7) {
    t8 = <Accordion analyticsActionName={t2} actionSection={actionSection} analyticsKey="card-details" iconComponent={t3} title="Card details" expandedByDefault={expandedByDefault}>{t7}</Accordion>;
    $[14] = actionSection;
    $[15] = expandedByDefault;
    $[16] = t2;
    $[17] = t7;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  return t8;
};
function _temp(bullet, idx) {
  return <li key={`marketing-bullet-${idx}`} className={cardDetailsListItem}><Typography variant="text">{bullet}</Typography></li>;
}